import axios from 'axios';

export const FETCH_EVENTS = 'FETCH_EVENTS';
export const FETCH_PAST_EVENTS = 'FETCH_PAST_EVENTS';
export const FETCH_FEATURE = 'FETCH_FEATURE';
export const SEARCH_FILTER = 'SEARCH_FILTER';
export const FETCH_REGIONS = 'FETCH_REGIONS';
export const REGION_FILTER = 'REGION_FILTER';
export const FETCH_CATEGORIES = 'FETCH_CATEGORIES';
export const CATEGORY_FILTER = 'CATEGORY_FILTER';
export const FETCH_EVENT_CONTACT_BOXES = 'FETCH_EVENT_CONTACT_BOXES';

export function fetchFeature() {
	return ( dispatch ) => {
		'use strict';
		const url = `${wpApiSettings.root}isda/v1/featured-event`;
		axios.get( url ).then( response => {
			dispatch( {
				          type: FETCH_FEATURE, payload: response.data
			          } );
		} );
	};
}

export function fetchEvents() {
	return ( dispatch ) => {
		'use strict';
		const url = `${wpApiSettings.root}isda/v1/events`;
		axios.get( url ).then( response => {
			dispatch( {
				          type: FETCH_EVENTS, payload: response.data
			          } );

			const categories = extractCategories( response.data );
			dispatch( {
				          type: FETCH_CATEGORIES, payload: categories
			          } );
		} );
	};

}

export function fetchPastEvents() {
	return ( dispatch ) => {
		'use strict';
		const url = `${wpApiSettings.root}isda/v1/past-events`;
		axios.get( url ).then( response => {
			dispatch( {
						type: FETCH_PAST_EVENTS, payload: response.data
					} );

			const categories = extractCategories( response.data );
			dispatch( {
						type: FETCH_CATEGORIES, payload: categories
					} );
		} );
	};

}

export function fetchEventContactBoxes() {
	return (dispatch) => {
		const url = `${wpApiSettings.root}isda/v1/event-contact-boxes`;
		axios.get(url).then(response => {
			dispatch({
				type: FETCH_EVENT_CONTACT_BOXES, payload: response.data,
			});
		});
	};
}

export function getFilteredEvents( searchTerm = '', regionTerm = '', categoryTerm = '', events = [] ) {
	var filteredEvents = events;

	if ( regionTerm.length ) {
		filteredEvents = filteredEvents.filter(
			event => filterByLocation( event, regionTerm )
		);
	}

	if ( searchTerm.length ) {
		filteredEvents = filteredEvents.filter( (event) =>{
			const term  = searchTerm.toLowerCase();
			const title = event.title.toLowerCase();
			const city  = event.city.name.toLowerCase();
			return title.includes(term) || filterTags(term, event.tags) || city.includes(term) || filterByLocationDual(event,term);
		});

	}

	if ( categoryTerm.length ) {
		filteredEvents = filteredEvents.filter( event => event.parent_child_cats.parent.name.includes( categoryTerm ) );
	}

	return filteredEvents;
}

function filterByLocation( thisEvent, regionTerm ){
	if ( typeof thisEvent.location === 'object' ) {
		return thisEvent.location.includes( regionTerm );
	}
}

function filterByLocationDual( thisEvent, term ){
	var dual_location = false;
	if ( typeof thisEvent.location === 'object' ) {
		const location = thisEvent.location;
		for (let property in location ) {
			let loc = location[property].toLowerCase();
			if ( loc.includes( term ) ) {
				dual_location = true;
			}
		}
	}

	return dual_location;
}

function filterTags(term, tags){
	var tagBool = false;
	if ( typeof tags === 'object' ) {
		for (let property in tags) {
			const tagName = tags[property].name.toLowerCase();
			if (tagName.includes(term)) {
				tagBool = true;
			}
		}
	}
	return tagBool;
}


export function searchByRegion( regionTerm ) {
	return ( dispatch ) => {
		'use strict';
		dispatch( {
			          type: REGION_FILTER, payload: regionTerm
		          } );
	};
}

export function searchByCategory( categoryTerm ) {
	return ( dispatch ) => {
		'use strict';
		dispatch( {
			          type: CATEGORY_FILTER, payload: categoryTerm
		          } );
	};
}

/**
 * Extracts unique regions from events list by looping through and returning an array
 * @param events
 */
//function extractRegions( events ) {
//	return events.map( event => {
//		console.log(event.region);
//		return event.region;
//	} );
////	.sort().filter( function( item, pos, ary ) {
////		return !pos || item != ary[ pos - 1 ];
////	} );
//}

export function fetchRegions() {
	//shows up to 50 categories, could change so per_page is dynamic if we have more than 50...
	return (dispatch) => {
		axios.get(
			`${wpApiSettings.root}isda/v1/event-locations`).
		     then(response => {
			dispatch({
		         type: FETCH_REGIONS, payload: response.data,
	         });
		});
	};
}

/**
 * Extracts unique categories from events list by looping through and returning an array
 * @param events
 */
function extractCategories( events ) {
	return events.map( event => {
		return event.parent_child_cats.parent.name;
	} ).sort().filter( function( item, pos, ary ) {
		return (!pos || item != ary[ pos - 1 ]
		       ) && item !== '';
	} );
}

export function searchEvents( searchTerm ) {
	return ( dispatch ) => {
		'use strict';
		dispatch( {
			          type: SEARCH_FILTER, payload: searchTerm
		          } );
	};
}

